const GOOGLE_MAPS_SCRIPT_ID = 'signs-google-maps-script';
const GOOGLE_MAPS_LOAD_PROMISE = '__signsGoogleMapsLoadPromise';

export const loadGoogleMaps = (apiKey) => {
  if (window.google?.maps?.Map && window.google.maps.marker) {
    return Promise.resolve();
  }

  if (window[GOOGLE_MAPS_LOAD_PROMISE]) {
    return window[GOOGLE_MAPS_LOAD_PROMISE];
  }

  window[GOOGLE_MAPS_LOAD_PROMISE] = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(GOOGLE_MAPS_SCRIPT_ID);
    const script = existingScript || document.createElement('script');

    const handleLoad = () => {
      if (window.google?.maps) {
        resolve();
      } else {
        reject(new Error('Google Maps loaded without the Maps API'));
      }
    };

    script.addEventListener('load', handleLoad, { once: true });
    script.addEventListener('error', () => reject(new Error('Failed to load Google Maps')), {
      once: true,
    });

    if (!existingScript) {
      script.id = GOOGLE_MAPS_SCRIPT_ID;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=weekly&libraries=marker`;
      script.async = true;
      script.crossOrigin = 'anonymous';
      document.head.appendChild(script);
    }
  }).catch((error) => {
    window[GOOGLE_MAPS_LOAD_PROMISE] = null;
    throw error;
  });

  return window[GOOGLE_MAPS_LOAD_PROMISE];
};
